import { applyMiddleware, combineReducers, compose, createStore as _createStore, StoreEnhancer } from 'redux';
import thunk from 'redux-thunk';

import { constructionProgressDataReducer } from '../../reducers/constructionProgressData';
import { favoriteReducer } from '../../reducers/favorite';
import { fullscreenGalleryReducer } from '../../reducers/fullscreenGallery';
import { newbuildingDataReducer } from '../../reducers/newbuildingData';
import { userDataReducer } from '../../reducers/userData';
import { IApplicationContext } from '../../types/application';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';
import { myHomeReducer } from '../../reducers/myHome';

let storeReminder: TReduxStore;

export interface ICreateReduxStoreparams {
  initialState: IApplicationState;
  context: IApplicationContext;
  debugEnabled?: boolean;
}

/**
 * Хелпер для создания Redux стора
 * @param preloadedState IApplicationState - предзагруженное состояние
 * @param httpApi IHttpApi - http клиент для запросов
 * @param debugEnabled boolean - флаг для дебагера
 */
export function createReduxStore({ initialState, context, debugEnabled }: ICreateReduxStoreparams) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    newbuildingData: newbuildingDataReducer,
    constructionProgressData: constructionProgressDataReducer,
    userData: userDataReducer,
    favorite: favoriteReducer,
    fullscreenGallery: fullscreenGalleryReducer,
    myHome: myHomeReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context)),
  ) as unknown as StoreEnhancer<IApplicationState>;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IApplicationState, {}>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
